import React from 'react'
import LoginAutodesk from '../../components/login/Login'
import { connect } from 'react-redux';

// Background
const bgImg = require('../../assets/images/water-bg.jpeg');
const bgStyle = {
  backgroundImage: `url(${bgImg})`
};

class Login extends React.Component {
  render() {
    return (
      <section className="login-page" style={bgStyle}>
        <LoginAutodesk/>
      </section>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.requestModelDataReducer.data
})

export default connect(mapStateToProps)(Login);